<form [formGroup]="form" (ngSubmit)="login()">
  <input type="text" formControlName="username" placeholder="Benutzer" />
  <input type="password" formControlName="password" placeholder="Passwort" />

  <button type="submit" [disabled]="form.invalid">Anmelden</button>
</form>
